// Write your code here
import './index.css'

const TransactionItem = props => {
  const {details, onDelete} = props
  const {id, amount, type, title} = details
  const onDeelete = () => {
    onDelete(id)
  }
  const types = type === 'INCOME' ? 'Income' : 'Expences'
  return (
    <li className="lists">
      <p className="p1">{title}</p>
      <p className="p1">{amount}</p>
      <p className="p1">{types}</p>

      <button
        data-testid="delete"
        type="button"
        onClick={onDeelete}
        className="delete_button"
      >
        <img
          className="delete_image"
          alt="delete"
          src="https://assets.ccbp.in/frontend/react-js/money-manager/delete.png"
        />
      </button>
    </li>
  )
}
export default TransactionItem
